import * as React from 'react';
import { Modal } from '../../../../../../../../Components/Modal';
import { useAccountDocumentArDocModalName } from '../../../../../accounts';

export const AccountDocumentDocumentModalContainer = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  const { data } = useAccountDocumentArDocModalName();
  return data ? (
    <Modal modal={data}>
      {children}
    </Modal>
  ) : null;
};
